import { OPEN_POPUP, CLOSE_POPUP } from "../actions/types";

const initialState = {
  workspaceShare: false,
  workspaceSetting: false,
};

//Hide and Show toast messages
export const popupReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case OPEN_POPUP:
      return {
        ...initialState,
        ...payload,
      };
    case CLOSE_POPUP:
      return {
        ...initialState,
        ...payload,
      };
    default:
      return state;
  }
};
